export default __webpack_public_path__ + "static/media/6.76b8262f.png";